<script setup>
defineEmits(['closeWindow'])
const props = defineProps(['height', 'boxSizing', 'display'])
const height = props.height ? props.heigh : '100%'
const boxSizing = props.boxSizing ? props.boxSizing : 'border-box'
</script>

<template>
    <!-- <Teleport > -->
    <Teleport to="#general-wrap">
        <div class="background" @click="$emit('closeWindow')">
            <div class="modal" @click.stop v-bind="$attrs">
                <span class="close-btn" @click="$emit('closeWindow')">X</span>
                <div class="header-block" v-if="$slots.header">
                    <slot name="header"></slot>
                </div>
                <div class="main-block" :class="$attrs.class">
                    <slot name="main" ></slot>
                </div>
                <div v-if="$slots.footer" class="footer-block">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped>
.background {
    width: 100vw;
    height: 100dvh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
    display: v-bind(display);
}

.modal {
    width: fit-content;
    /* min-width: 800px; */
    height: v-bind(height);
    max-height: 85vh;
    min-height: fit-content;
    background-color: #15296c;
    /* filter: brightness(80%); */
    border-radius: 20px;
    color: white;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 20px;
    padding-top: 0;
    transform: translate(-50%, -50%);
}

.header-block {
    position: relative;
    height: fit-content;
    width: 100%;
    text-align: center;
    overflow: visible;
    display: flex;
    flex-direction: column;
}

:deep(.header-block p) {
    margin-bottom: 0.5rem;
}

.main-block {
    position: relative;
    height: 85%;
    width: 100%;
    padding: 10px;
    overflow-y: auto;
    box-sizing: v-bind(boxSizing);
}

.main-block::-webkit-scrollbar {
    width: 0.5rem;
    background-color: linear-gradient(#15296c, #0B1146);
    border-radius: 20px;
}

.main-block::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.main-block::-webkit-scrollbar-thumb {
    background: linear-gradient(#000000, #15296c);
    border-radius: 10px;
}

.footer-block {
    width: 100%;
    height: 10%;
}

:deep(button.action-btn) {
    background-color: yellow;
    border-color: yellow;
}

:deep(.active-link) {
    color: white;
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    color: white;
}

.close-btn:hover {
    cursor: pointer;
}

@media screen and (max-width: 1000px) {

    .modal {
        /* width: 100%; */
        height: 90vh;
        max-height: unset;
    }

    .main-block {
        width: 80vw;
        padding: 0;
    }

    .main-block.main-block-all {
        width: fit-content;
    }
}

@media screen and (max-width: 800px) {


    .main-block {
        padding: 0;
        width: 90vw;
    }
}

@media screen and (max-height: 350px) {
    .modal {
        height: 97dvh;
        /* margin-top: 10px; */
    }

    .close-btn {
        font-size: 30px;
    }
}
</style>